import React from "react";
import { customerEnquiryItinerary } from "@travellocal/utils/webRoutes";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import MessageThread from "../../../../../shared/components/messaging/thread";
import { apiPromiseHook } from "../../../../../shared/flux/actions/enterHooks";
import { MatchState } from "../../../../../shared/helpers/reduxHelpers";
import { ActionPromises } from "../../../../state/actionPromises";
import { EnterHookPromises } from "../../../../state/enterHookPromises";

import "./messaging.scss";

interface StateProps {
  customerEnquiry: IState<IEnquiryOutput>;
}

interface DispatchProps {
  markMessagesRead: (enquiryId: number) => any;
}

type Props = DispatchProps & StateProps;

const stateToProps = (state: IWebStoreState): StateProps => {
  return {
    customerEnquiry: state.customerEnquiry,
  };
};

const dispatchToProps = (dispatch: Dispatch<IWebStoreState>): DispatchProps => {
  return {
    markMessagesRead: (enquiryId: number) => dispatch(ActionPromises.markMessagesRead(enquiryId)),
  };
};

class CustomerEnquiryMessagingComponent extends React.Component<Props, {}> {
  public componentDidMount() {
    const enq = this.props.customerEnquiry.data;
    if (!enq.messagingSummary.customerUpToDate) {
      this.props.markMessagesRead(enq.id);
    }
  }
  public render() {
    const enquiry = this.props.customerEnquiry;
    const columnClasses = "column is-10-tablet is-offset-1-tablet is-8-widescreen is-offset-2-widescreen";

    return (
      <div id="link-from-new-message-card" className="customer-enquiry-messaging columns is-marginless">
        <div className={columnClasses}>
          {MatchState(enquiry, {
            data: () => (
              <MessageThread
                itineraryRoute={customerEnquiryItinerary(enquiry.data.id)}
                enquiry={enquiry.data}
              />
            ),
          })}
        </div>
      </div>
    );
  }
}

export const Messages = connect(stateToProps, dispatchToProps)(CustomerEnquiryMessagingComponent);
export const MessagesOnEnter = apiPromiseHook<any>(
  EnterHookPromises.messagesByEnquiryId("enquiryId"),
  EnterHookPromises.customerEnquiryData("enquiryId"),
);
